import { useSelector } from 'react-redux';

import { EVENT_CONSTANTS } from '@/services';
import {
  selectUserAudienceRegions,
  selectUserCompliance,
  useFetchNewEpisodesQuery,
} from '@/store';

import { EpisodeCardCarousel } from '../EpisodeCardCarousel';

const location = {
  page: EVENT_CONSTANTS.PAGE.DISCOVER,
};

export const NewGeneralEpisodesCarousel = () => {
  const audienceRegions = useSelector(selectUserAudienceRegions);
  const compliance = useSelector(selectUserCompliance);

  const {
    data: newEpisodes,
    isError,
    isLoading,
    isUninitialized,
  } = useFetchNewEpisodesQuery({
    isTechnical: false,
    compliance,
    audienceRegions,
    applyRelevanceBoost: true,
  });

  return (
    <>
      {isError || !newEpisodes ? null : (
        <EpisodeCardCarousel
          title="New Episodes"
          uKey="New Episodes"
          episodes={newEpisodes}
          isLoading={isLoading || isUninitialized}
          referrer={location}
        />
      )}
    </>
  );
};
